/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { addUserByLoyaltyCardAsync, createAddUserByLoyaltyCardInput } from './DataActionExtension.g';
/**
 * AddUserByLoyaltyCard Input Action
 */
export class AddUserByLoyaltyCardInput implements Msdyn365.IActionInput {
    // Construct the input needed to run the action
    public loyaltyNumber: string;
    public zipCode: string;
    public email: string;

    constructor(loyaltyNumber: string, zipCode: string, email: string) {
        this.loyaltyNumber = loyaltyNumber;
        this.zipCode = zipCode;
        this.email = email;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ADDUSERBYLOYALTYCARD`;
    public getCacheObjectType = () => 'success';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// Create a data model here or import one to capture the response of the action
export interface IAddUserByLoyaltyCardData {
    success: boolean;
    message: string;
}

async function action(input: AddUserByLoyaltyCardInput, ctx: Msdyn365.IActionContext): Promise<IAddUserByLoyaltyCardData> {
    const response = await addUserByLoyaltyCardAsync({ callerContext: ctx }, input.loyaltyNumber, input.zipCode, input.email);
    return { success: response?.Success || false, message: response?.Message || '' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IAddUserByLoyaltyCardData>>action,
    id: 'AddUserByLoyaltyCard',
    input: inputData => {
        return createAddUserByLoyaltyCardInput(inputData.loyalty, inputData.zip, inputData.email);
    }
});
